// This file is intentionally left empty as we're using the theme's built-in variant-selects custom element
// The functionality is already implemented in global.js

// If you need to add custom functionality, you can extend the VariantSelects class like this:
/*
document.addEventListener('DOMContentLoaded', () => {
  // Wait for the custom element to be defined
  if (customElements.get('variant-selects')) {
    const originalVariantSelects = customElements.get('variant-selects');
    
    // Create a new class that extends the original
    class ExtendedVariantSelects extends originalVariantSelects {
      constructor() {
        super();
        // Add your custom initialization here
      }
      
      // Override or add methods as needed
      connectedCallback() {
        super.connectedCallback();
        // Add your custom code here
      }
    }
    
    // Define the extended class
    customElements.define('extended-variant-selects', ExtendedVariantSelects);
  }
});
*/

// The Dawn theme uses a custom element approach with a publish/subscribe pattern
// The VariantSelects class in global.js handles the variant selection
// The ProductInfo class in product-info.js handles the UI updates

// Make sure the variant-selects custom element is properly initialized
document.addEventListener('DOMContentLoaded', () => {
  // Check if the variant-selects custom element is defined
  if (!customElements.get('variant-selects')) {
    console.error('The variant-selects custom element is not defined. Make sure global.js is loaded.');
    return;
  }
  
  // Check if the product-info custom element is defined
  if (!customElements.get('product-info')) {
    console.error('The product-info custom element is not defined. Make sure product-info.js is loaded.');
    return;
  }
  
  // Make sure variant strings are available
  window.variantStrings = window.variantStrings || {
    addToCart: 'Add to cart',
    soldOut: 'Sold out',
    unavailable: 'Unavailable'
  };
  
  // Log a message to confirm that the variant selector is initialized
  console.log('Variant selector initialized');
});

// Wait for Dawn's scripts to load completely
window.addEventListener('load', function() {
  // Make sure Dawn's components are defined
  if (!customElements.get('variant-selects') || !customElements.get('product-info')) {
    console.error('Dawn components not loaded yet');
    return;
  }

  class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this.productForm = document.querySelector('form[action*="/cart/add"]');
      this.productInfo = document.querySelector('product-info');
      this.variantData = this.querySelector('[data-variants]');
      
      if (!this.productForm || !this.productInfo || !this.variantData) {
        console.error('Required elements not found');
        return;
      }

      this.variants = JSON.parse(this.variantData.textContent);
      this.setupEventListeners();
      this.updateFromUrl();
    }

    setupEventListeners() {
      this.querySelectorAll('.product-form__input input[type="radio"]').forEach(input => {
        input.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    onVariantChange() {
      const selectedOptions = Array.from(this.querySelectorAll('.product-form__input')).map(select => {
        const checked = select.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      console.log('Selected options:', selectedOptions);

      const matchingVariant = this.variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      console.log('Matching variant:', matchingVariant);

      if (matchingVariant) {
        // Update Dawn's product-info component
        this.productInfo.variant = matchingVariant;

        // Update form ID
        const input = this.productForm.querySelector('input[name="id"]');
        if (input) input.value = matchingVariant.id;

        // Update URL
        if (window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', matchingVariant.id);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        }

        // Dispatch events that Dawn listens for
        this.productInfo.dispatchEvent(
          new CustomEvent('variant:changed', {
            detail: { 
              variant: matchingVariant,
              sectionId: this.dataset.section
            },
            bubbles: true
          })
        );

        // Force section refresh
        const section = document.getElementById(this.dataset.section);
        if (section) {
          section.dispatchEvent(
            new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: this.dataset.section }
            })
          );
        }
      }
    }

    updateFromUrl() {
      const searchParams = new URLSearchParams(window.location.search);
      const variantId = searchParams.get('variant');
      
      if (variantId) {
        const variant = this.variants.find(v => v.id.toString() === variantId);
        if (variant) {
          // Select the correct radio buttons
          variant.options.forEach((option, index) => {
            const radio = this.querySelector(`input[type="radio"][value="${option}"]`);
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change'));
            }
          });
        }
      }
    }
  }

  // Register our custom element
  customElements.define('extended-variant-selects', VariantSelector);
  console.log('Variant selector registered');
});

document.addEventListener('DOMContentLoaded', function() {
  // Find all variant selectors
  const variantSelectors = document.querySelectorAll('.product-form__input');
  if (!variantSelectors.length) {
    console.log('No variant selectors found');
    return;
  }

  // Get the product form
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) {
    console.log('Product form not found');
    return;
  }

  // Get variants JSON
  const variantJson = document.querySelector('[data-variants]');
  if (!variantJson) {
    console.log('Variants data not found');
    return;
  }

  // Parse variants data
  const variants = JSON.parse(variantJson.textContent);
  console.log('Loaded variants:', variants);

  // Function to format money
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    return '₹' + (cents / 100.0).toFixed(2);
  }

  // Function to update media gallery
  function updateMediaGallery(variant) {
    if (!variant?.featured_media?.id) return;

    console.log('Updating media gallery with media ID:', variant.featured_media.id);

    // Get the media gallery component
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) {
      console.log('Media gallery not found');
      return;
    }

    // Find all media items
    const mediaItems = document.querySelectorAll('.product__media-item');
    mediaItems.forEach(item => {
      const mediaId = item.getAttribute('data-media-id');
      const isCurrentVariant = mediaId && mediaId.endsWith(variant.featured_media.id);
      
      // Update visibility and active state
      item.classList.toggle('is-active', isCurrentVariant);
      item.classList.toggle('hidden', !isCurrentVariant);
      
      // Update aria attributes
      if (isCurrentVariant) {
        item.removeAttribute('hidden');
        item.setAttribute('aria-hidden', 'false');
      } else {
        item.setAttribute('hidden', '');
        item.setAttribute('aria-hidden', 'true');
      }
    });

    // Update slider counter if it exists
    const sliderCounter = document.querySelector('.slider-counter--current');
    if (sliderCounter) {
      const activeIndex = Array.from(mediaItems).findIndex(item => 
        item.getAttribute('data-media-id').endsWith(variant.featured_media.id)
      );
      if (activeIndex !== -1) {
        sliderCounter.textContent = (activeIndex + 1).toString();
      }
    }

    // Update thumbnails if they exist
    const thumbnails = document.querySelectorAll('.thumbnail-list__item');
    thumbnails.forEach(thumb => {
      const thumbMediaId = thumb.getAttribute('data-media-id');
      const isCurrentVariant = thumbMediaId && thumbMediaId.endsWith(variant.featured_media.id);
      thumb.classList.toggle('is-active', isCurrentVariant);
      
      const thumbButton = thumb.querySelector('button');
      if (thumbButton) {
        thumbButton.setAttribute('aria-current', isCurrentVariant ? 'true' : 'false');
      }
    });

    // Dispatch events that Dawn's components listen for
    mediaGallery.dispatchEvent(
      new CustomEvent('media:change', {
        detail: {
          mediaId: variant.featured_media.id.toString()
        },
        bubbles: true
      })
    );

    mediaGallery.dispatchEvent(
      new CustomEvent('variant:media:change', {
        detail: { 
          variant: variant,
          mediaId: variant.featured_media.id.toString()
        },
        bubbles: true
      })
    );
  }

  // Function to update the UI
  function updateUI(variant) {
    if (!variant) return;

    console.log('Updating UI for variant:', variant);

    // Update variant ID input
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update URL
    if (window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    // Update price display and availability
    const priceContainer = document.querySelector('.price');
    if (priceContainer) {
      // Remove all state classes first
      priceContainer.classList.remove('price--sold-out', 'price--on-sale', 'price--unavailable');
      
      // Add appropriate state class
      if (!variant.available) {
        priceContainer.classList.add('price--sold-out');
      } else if (variant.compare_at_price > variant.price) {
        priceContainer.classList.add('price--on-sale');
      }

      const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
      const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');
      const comparePriceElement = priceContainer.querySelector('.price__sale .price-item--regular');
      const regularPriceContainer = priceContainer.querySelector('.price__regular');
      const salePriceContainer = priceContainer.querySelector('.price__sale');
      const soldOutBadge = priceContainer.querySelector('.badge--sold-out');

      // Handle sold out badge
      if (soldOutBadge) {
        soldOutBadge.style.display = !variant.available ? 'inline-block' : 'none';
      }

      if (variant.compare_at_price > variant.price) {
        // On sale
        if (regularPriceContainer) regularPriceContainer.style.display = 'none';
        if (salePriceContainer) salePriceContainer.style.display = 'block';
        if (salePriceElement) salePriceElement.textContent = formatMoney(variant.price);
        if (comparePriceElement) comparePriceElement.textContent = formatMoney(variant.compare_at_price);
      } else {
        // Regular price
        if (regularPriceContainer) regularPriceContainer.style.display = 'block';
        if (salePriceContainer) salePriceContainer.style.display = 'none';
        if (regularPriceElement) regularPriceElement.textContent = formatMoney(variant.price);
      }
    }

    // Update inventory status
    updateInventoryStatus(variant);

    // Update quantity selector
    updateQuantitySelector(variant);

    // Update add to cart button
    const addToCartButton = document.querySelector('[name="add"]');
    if (addToCartButton) {
      const buttonText = variant.available ? window.variantStrings?.addToCart || 'Add to cart' : window.variantStrings?.soldOut || 'Sold out';
      addToCartButton.textContent = buttonText;
      addToCartButton.disabled = !variant.available;
      addToCartButton.classList.toggle('disabled', !variant.available);

      // Update button attributes
      addToCartButton.setAttribute('data-variant-id', variant.id);
      if (variant.available) {
        addToCartButton.removeAttribute('disabled');
      } else {
        addToCartButton.setAttribute('disabled', 'disabled');
      }
    }

    // Update media gallery
    updateMediaGallery(variant);

    // Dispatch variant change event that Dawn components listen for
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      productInfo.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: {
            variant: variant,
            sectionId: productInfo.dataset.section
          },
          bubbles: true
        })
      );
    }

    // Force section refresh
    const sectionId = productForm.closest('[data-section]')?.dataset.section;
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId }
          })
        );
      }
    }
  }

  // Function to update inventory status
  function updateInventoryStatus(variant) {
    const inventoryElement = document.querySelector('.product__inventory');
    if (!inventoryElement) return;

    // Clear existing classes
    inventoryElement.classList.remove('product__inventory--sold-out', 'product__inventory--low', 'product__inventory--in-stock');

    if (!variant.available) {
      inventoryElement.textContent = window.variantStrings?.soldOut || 'Sold out';
      inventoryElement.classList.add('product__inventory--sold-out');
    } else if (variant.inventory_management === 'shopify' && variant.inventory_quantity != null) {
      if (variant.inventory_quantity <= 0 && variant.available) {
        inventoryElement.textContent = window.variantStrings?.preOrder || 'Pre-order';
        inventoryElement.classList.add('product__inventory--low');
      } else if (variant.inventory_quantity <= 5) {
        inventoryElement.textContent = `${variant.inventory_quantity} ${window.variantStrings?.leftInStock || 'left in stock'}`;
        inventoryElement.classList.add('product__inventory--low');
      } else {
        inventoryElement.textContent = window.variantStrings?.inStock || 'In stock';
        inventoryElement.classList.add('product__inventory--in-stock');
      }
    } else {
      inventoryElement.textContent = window.variantStrings?.inStock || 'In stock';
      inventoryElement.classList.add('product__inventory--in-stock');
    }

    // Update visibility
    inventoryElement.style.display = 'block';
  }

  // Function to update quantity selector
  function updateQuantitySelector(variant) {
    const quantityInput = document.querySelector('.quantity__input');
    if (!quantityInput) return;

    if (variant.inventory_management === 'shopify' && variant.inventory_quantity != null) {
      // Set max quantity
      quantityInput.setAttribute('max', variant.inventory_quantity.toString());
      
      // If current quantity is more than available, adjust it
      const currentQty = parseInt(quantityInput.value, 10);
      if (currentQty > variant.inventory_quantity) {
        quantityInput.value = variant.inventory_quantity;
      }

      // Enable/disable quantity buttons based on inventory
      const minusButton = document.querySelector('.quantity__button[name="minus"]');
      const plusButton = document.querySelector('.quantity__button[name="plus"]');
      
      if (minusButton && plusButton) {
        const currentValue = parseInt(quantityInput.value, 10);
        minusButton.disabled = currentValue <= 1;
        plusButton.disabled = currentValue >= variant.inventory_quantity;
      }
    } else if (!variant.available) {
      // Disable quantity selector if variant is not available
      quantityInput.disabled = true;
      quantityInput.value = '0';
      
      const buttons = document.querySelectorAll('.quantity__button');
      buttons.forEach(button => button.disabled = true);
    } else {
      // Reset to default state if no inventory management
      quantityInput.disabled = false;
      quantityInput.removeAttribute('max');
      
      const buttons = document.querySelectorAll('.quantity__button');
      buttons.forEach(button => button.disabled = false);
    }
  }

  // Function to find variant based on selected options
  function getSelectedVariant() {
    const selectedOptions = Array.from(variantSelectors).map(selector => {
      const input = selector.querySelector('input[type="radio"]:checked');
      return input ? input.value : null;
    });

    console.log('Selected options:', selectedOptions);

    const matchingVariant = variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    console.log('Matching variant:', matchingVariant);
    return matchingVariant;
  }

  // Add change event listeners to all variant selectors
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function(event) {
      const variant = getSelectedVariant();
      if (variant) {
        updateUI(variant);
      }
    });
  });

  // Initialize with current variant if one is selected
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  if (variantId) {
    const currentVariant = variants.find(v => v.id.toString() === variantId);
    if (currentVariant) {
      updateUI(currentVariant);
    }
  }
}); 